// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NLjBf","left":"styles_left__1QTx_"};